import React from 'react';
import { useTranslation } from 'react-i18next';
import { InlineNotification } from 'eds/Notifications';
import { ENotificationVariant } from 'eds/Notifications/types';

interface IProps {
  count: number;
}

const OOSMessage: React.FC<IProps> = ({ count }) => {
  const { t } = useTranslation();
  return (
    <InlineNotification
      variant={ENotificationVariant.WARNING}
      title={`${count} ${t('oosReplacement.title')}`}
      description={t('oosReplacement.subTitle')}
      showBorder
    />
  );
};

export default OOSMessage;
